document.addEventListener('DOMContentLoaded', function () {
  var items = document.querySelectorAll('.hok-reveal');

  if (!('IntersectionObserver' in window)) {
    items.forEach(function(item){ item.classList.add('hok-visible'); });
    return;
  }

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('hok-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.16 });

  items.forEach(function(item) {
    observer.observe(item);
  });
});
document.querySelectorAll('.hok-reveal').forEach(el=>{

const observer=new IntersectionObserver(entries=>{

entries.forEach(entry=>{

if(entry.isIntersecting){

entry.target.classList.add('is-visible');

}

});

},{threshold:.18});

observer.observe(el);

});